import { IPartnerListItem, IWhoamiResponse } from '@/domain/auth/interfaces/user';
import { createStore } from '@/lib/zustand';

type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  user: IWhoamiResponse | null;
  partnersList: Array<IPartnerListItem>;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (user: IWhoamiResponse) => void;
  setPartnersList: (list: Array<IPartnerListItem>) => void;
  setInitialized: (value: boolean) => void;
  clearTokens: () => void;
};

export const authStore = createStore<AuthState>((set) => ({
  isAuthenticated: false,
  isInitialized: false,
  accessToken: null,
  refreshToken: null,
  user: null,
  partnersList: [],
  setTokens: (accessToken, refreshToken) => set({ isAuthenticated: true, accessToken, refreshToken }),
  setUser: (user) => set({ user }),
  setPartnersList: (partnersList) => set({ partnersList }),
  setInitialized: (value) => set({ isInitialized: value }),
  clearTokens: () =>
    set({
      isAuthenticated: false,
      accessToken: null,
      refreshToken: null,
      user: null,
      partnersList: [],
    }),
}));
